import { Order, Route } from "@web-app/types";
import { routeHasEsa } from "@web-app/utils/order";

export const getExternalAssigneeTypeFromId = (
  externalAssigneeId?: string,
): string => {
  if (!externalAssigneeId) return "";
  if (externalAssigneeId.split("-")[0] === "uber") return "uber";
  if (externalAssigneeId.split("_")[0] === "doordash") return "doordash";
  if (externalAssigneeId.startsWith("roadie-")) return "roadie";
  if (externalAssigneeId.startsWith("expedite-")) return "expedite";
  if (externalAssigneeId.startsWith("onfleet-")) return "onfleet";
  return "";
};

type ExternalAssigneeLike = {
  deletedAt: Date | null;
  remark?: string;
  type: string;
};

/**
 * Resolves the provider a route was handed off to. Orders inside such a route
 * are delivered by that provider, so they inherit this value.
 */
export const getRouteExternalAssigneeType = (
  route?: {
    externalAssignee?: ExternalAssigneeLike | null;
    externalAssigneeId?: string | null;
  } | null,
): string => {
  if (!route) return "";

  const type =
    route.externalAssignee?.deletedAt === null
      ? route.externalAssignee.type
      : getExternalAssigneeTypeFromId(route.externalAssigneeId ?? undefined);

  // Expedite is only a provider once the offer has been accepted
  if (type === "expedite" && route.externalAssignee?.remark !== "accepted") {
    return "";
  }

  return type ?? "";
};

export const useExternalAssignee = (order: Order, route?: Route | null) => {
  let externalAssigneeType = "";
  if (order.externalAssigneeId?.split("-")[0] === "uber") {
    externalAssigneeType = "uber";
  }

  if (
    order.externalAssignee?.type === "doordash" &&
    order.externalAssignee?.deletedAt === null
  ) {
    externalAssigneeType = "doordash";
  }

  if (
    order.externalAssignee?.type === "roadie" &&
    order.externalAssignee?.deletedAt === null
  ) {
    externalAssigneeType = "roadie";
  }

  if (
    order.externalAssignee?.type === "expedite" &&
    order.externalAssignee?.deletedAt === null &&
    order.externalAssignee?.remark == "accepted"
  ) {
    externalAssigneeType = "expedite";
  }

  if (
    order.externalAssignee?.type === "onfleet" &&
    order.externalAssignee?.deletedAt === null
  ) {
    externalAssigneeType = "onfleet";
  }

  const showExternalAssigneeLogo = !(order.routeId && routeHasEsa(route));

  return {
    externalAssigneeType,
    showExternalAssigneeLogo,
  };
};
